import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

import typographyStyle from '../../assets/jss/material-dashboard-pro-react/components/typographyStyle.jsx';

function Success({ ...props }) {
  const { classes, children, help } = props;
  return (
    <div
      className={
        classes.defaultFontStyle + ' ' + classes.successText + ' ' + (help ? classes.helpText : '')
      }>
      {children}
    </div>
  );
}

Success.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(typographyStyle)(Success);
